<div class="slider" #slider [style.width]="settings.width">
  <ul class="slider-inner" #track
      [ngStyle]="sliderWrapperStyle"
      (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
    <li *ngFor="let item of items; let i = index" class="slider-item" [ngStyle]="sliderItemStyle"
        [class.no-pointer]="!settings.moveSliderOnSlideClick"
        (click)="onSlideClick(i)">
      <ng-container [ngTemplateOutlet]="item?.tpl"></ng-container>
    </li>
  </ul>

  <ul class="slider-dots-list" *ngIf="settings.showDots && contentItemsLength > 1">
    <li class="slider-dot" *ngFor="let item of dots; let i = index" (click)="onDotClick(i)" #dot>
      <div class="slider-dot__inner"></div>
    </li>
  </ul>
</div>

<div class="slider-buttons-list" *ngIf="settings.showControls && contentItemsLength > 1">
  <a class="slider-button slider-button--prev i-state i-state--point" (click)="prev()"></a>
  <a class="slider-button slider-button--next i-state i-state--point" (click)="next()"></a>
</div>
